import React from "react";
import { ArrowIconComponent } from "./arrow-icon.component";
import styles from "./revenue-section.module.scss";

export const RevenueSection = ({ isDistributor = true }) => {
  const revenueData = isDistributor
    ? [
        {
          title: "Won Revenue",
          percentage: "-8.3%",
          amount: "€43K",
          mrr: "€ 3 800.00  MRR",
        },
        {
          title: "Pipeline Revenue",
          percentage: "+18.3%",
          amount: "€283K",
          mrr: "€ 20 100.00 MRR",
        },
        {
          title: "Lost Revenue",
          percentage: "-22.5%",
          amount: "€156K",
          mrr: "€ 13 400.00 MRR",
        },
        {
          title: "Churn",
          percentage: "-12%",
          amount: "€25K",
          mrr: "€ 2 200.00 MRR",
        },
      ]
    : [
        {
          title: "Total Won Revenue",
          percentage: "-8.3%",
          amount: "€43K",
          mrr: "€ 3 800.00  MRR",
        },
        {
          title: "Total Pipeline Revenue",
          percentage: "+18.3%",
          amount: "€283K",
          mrr: "€ 20 100.00 MRR",
        },
        {
          title: "Total Lost Revenue",
          percentage: "-22.5%",
          amount: "€156K",
          mrr: "€ 13 400.00 MRR",
        },
        {
          title: "Total Churn",
          percentage: "-12%",
          amount: "€25K",
          mrr: "€ 2 200.00 MRR",
        },
      ];

  return (
    <section className={styles.revenueSection}>
      {revenueData.map((card, index) => (
        <article key={index} className={styles.revenueCard}>
          <header className={styles.revenueCardHeader}>
            <div className={styles.revenueCardHeaderContent}>
              <h3 className={styles.revenueTitle}>
                {card.title}
              </h3>

              <div className={`${styles.revenueInlineFlex} ${styles.revenueItemsCenter} ${styles.revenueRelative} ${styles.revenueFlex0Auto}`}>
                <div className={`${styles.revenueInlineFlex} ${styles.revenueItemsCenter} ${styles.revenueRelative} ${styles.revenueFlex0Auto}`}>
                    <ArrowIconComponent isPositive={!card.percentage.startsWith('-')} />
                  <span
                    className={`${styles.revenuePercentage} ${
                      !card.percentage.startsWith('-')
                        ? styles.revenuePercentagePositive
                        : styles.revenuePercentageNegative
                    } ${index === 3 ? styles.revenuePercentageFixedWidth : styles.revenuePercentageNormal}`}
                  >
                    {card.percentage}
                  </span>
                </div>
              </div>
            </div>
          </header>

          <div className={styles.revenueMetricValueContainer}>
            <p className={styles.revenueAmount}>
              {card.amount}
            </p>
          </div>

          <p className={styles.revenueMrr}>
            {card.mrr}
          </p>
        </article>
      ))}
    </section>
  );
};